import { defineStore } from 'pinia'
import axios from "axios";
import ApiHelper from "@/helpsers/api.helper";
import authHelper from "@/helpsers/auth.helper";
import { ProductStatus } from '@/helpsers/product.helper';

export const useProductStore = defineStore({
    id: 'products',
    state: () => {
        return {
            products: [],
            page: 1,
            onPage: 25,
            total: 0,
            search: null,
            productType: null,
            productStatus: null,
            vendor: null,
            order: null,
            isLoading: false,
            alertMessage: '',
            alertType: '',
            sortTypes: [],
            productTypes: [],
            productStatuses: ['all', ProductStatus.DRAFT, ProductStatus.ACTIVE, ProductStatus.ARCHIVED],
            vendors: [],
        }
    },
    actions: {
        async fetchProducts() {
            this.isLoading = true;
            let requestParams = {
                onPage: this.onPage,
                pageNumber: this.page,
            }
            if (this.order)
                requestParams.order = this.order;
            if (this.productType)
                requestParams.productType = this.productType;
            if (this.productStatus)
                requestParams.productStatus = this.productStatus;
            if (this.vendor)
                requestParams.vendor = this.vendor; 
            if (this.search)
                requestParams.search = this.search;

            axios.get(ApiHelper.getAdminAllProductsUrl(), {
                headers: authHelper.authHeader(),
                params: requestParams
            }).then(result => {
                let data = result.data;
                this.total = data.total ?? 0;
                this.onPage = data.onPage ?? 25;
                this.page = data.pageNumber ?? 1;
                this.products = data.data ?? [];
                this.isLoading = false;
            }).catch(errorResponse => {
                this.isLoading = false;
            })
        },
        async fetchSortTypes() {
            axios.get(ApiHelper.getAdminProductSortTypesUrl(), {
                headers: authHelper.authHeader(),
            }).then(result => {
                this.sortTypes = result.data ?? [];
            }).catch(errorResponse => {
            })
        },
        async fetchProductTypes() {
            axios.get(ApiHelper.getAdminProductTypesUrl(), {
                headers: authHelper.authHeader(),
            }).then(result => {
                this.productTypes = result.data ?? [];
                if (this.productTypes.length > 0) {
                    this.productTypes.unshift({name: 'all'})
                }
            }).catch(errorResponse => {
            })
        },
        async fetchVendors() {
            axios.get(ApiHelper.getAdminProducersUrl(), {
                headers: authHelper.authHeader(),
            }).then(result => {
                this.vendors = result.data.data?.map(item => item.slug) ?? [];
                if (this.vendors.length > 0) {
                    this.vendors.unshift('all')
                }
            }).catch(errorResponse => {})
        }
    },
});
